import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FileType } from '@shared-ui-lib/document-download/document-download.model'
import { BehaviorSubject } from 'rxjs'

@Component({
    selector: 'app-document-download',
    templateUrl: './document-download.component.html',
    styleUrls: ['./document-download.component.scss'],
})
export class DocumentDownloadComponent {
    FileType = FileType

    @Input()
    fileType?: FileType

    @Input()
    name?: string

    @Input()
    date?: Date

    @Input()
    showNewDocumentBadge = false

    @Input()
    sizeInBytes?: number

    @Input()
    tooltip?: string

    @Input()
    loading = false

    disabled$ = new BehaviorSubject<boolean>(false)
    @Input()
    set disabled(disabled: boolean) {
        this.disabled$.next(disabled)
    }

    @Output()
    readonly documentClick = new EventEmitter<void>()
}
